import { render, staticRenderFns } from "./CampaignIntegrationMatchSetting.vue?vue&type=template&id=3725733c&"
import script from "./CampaignIntegrationMatchSetting.vue?vue&type=script&lang=js&"
export * from "./CampaignIntegrationMatchSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports